import axios from "axios";
import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { apiLink } from "../../helpers/constantVariables";
import { getclusterbyDomain } from "../../services/white_label";
import { useStores } from "../../store";

const InterviewFeedback = ({ onSubmit, theme = "light" }) => {
  const { UserStore } = useStores();
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState("");

  const handleRatingChange = (value) => {
    setRating(value);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Perform submit logic here
    console.log("Rating:", rating);
    console.log("Comment:", comment);
    // Reset form values

    if (!rating) {
      return alert("Please give the rating");
    }

    const resp = onSubmit && onSubmit({ rating, comment });

    /* ---------------------- Calling the feedback api here --------------------- */
    if (resp) {
      const user = UserStore.userDetails;
      const body = {
        subject: "interview feedback",
        body: comment,
        rating: rating,
        uDetails: user?._id,
      };
      let newBody = body;
      newBody = {
        ...newBody,
        cluster: getclusterbyDomain(),
      };

      axios
        .post(`${apiLink}/suggestion/new-suggestion`, newBody)
        .then((res) => {
          console.log(res.status);
        })
        .catch((err) => {
          console.log(err);
        });

      setRating(0);
      setComment("");
    }
  };

  return (
    <div
      className="w-[400px] border rounded-xl mx-auto my-auto p-4 gil-reg"
      style={{
        borderColor: theme === "dark" ? "#374151" : "#e2e8f0",
        color: theme === "dark" ? "#fff" : "#222",
        background: theme === "dark" ? "#18181b" : "#fff",
      }}
    >
      <h2
        className="text-2xl gil-bold mb-4"
        style={{
          color: theme === "dark" ? "#fff" : "#222",
        }}
      >
        Feedback
      </h2>
      <form onSubmit={handleSubmit}>
        <div className="flex items-center mb-4">
          <span className="mr-2">Rate:</span>
          {[1, 2, 3, 4, 5].map((value) => (
            <button
              key={value}
              type="button"
              onClick={() => handleRatingChange(value)}
              className={`text-xl ${
                value <= rating ? "text-yellow" : "text-gray-400"
              }`}
            >
              <FaStar size="2.5rem" />
            </button>
          ))}
        </div>
        <div className="mb-4">
          <label
            htmlFor="comment"
            className="block mb-2 font-medium"
            style={{
              color: theme === "dark" ? "#fff" : "#222",
            }}
          >
            Comment:
          </label>
          <textarea
            required={false}
            id="comment"
            value={comment}
            onChange={handleCommentChange}
            placeholder="How was your experience?"
            className="w-full p-2 border rounded-md"
            style={{
              background: theme === "dark" ? "#27272a" : "#fff",
              borderColor: theme === "dark" ? "#52525b" : "#d1d5db",
              color: theme === "dark" ? "#fff" : "#222",
            }}
            rows={4}
          />
        </div>
        <button
          type="submit"
          className="px-4 py-2 text-white bg-primary rounded-md "
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default InterviewFeedback;
